table{width:100%}.col-md-4{margin-left:auto;margin-bottom:10px}
/*# sourceMappingURL=table.component-GDLB2LD5.css.map */
